import { v4 as uuidv4 } from 'uuid';

export const clearHighlightLines = () => {
  const elements = document.querySelectorAll('[data-index]');
  elements.forEach(el => {
    el.style.borderTop = '';
    el.style.borderBottom = '';
  });
};

export const getDropData = (e, liveRegion) => {
  const data = e.dataTransfer.getData('text/plain');
  try {
    return JSON.parse(data);
  } catch (error) {
    console.error('Error parsing drop data:', error);
    if (liveRegion) liveRegion.textContent = 'Error parsing drop data';
    return null;
  }
};

export const scrollColumn = (e, column) => {
  const rect = column.getBoundingClientRect();
  const scrollZoneHeight = rect.height * 0.15;
  const maxScrollSpeed = 150;

  const columnItemsBox = column.querySelector('.column-items-box');
  if (!columnItemsBox) {
    return;
  }

  let scrollSpeed = 0;

  if (e.clientY < rect.top + scrollZoneHeight) {
    const distanceToTop = rect.top + scrollZoneHeight - e.clientY;
    scrollSpeed = (distanceToTop / scrollZoneHeight) * maxScrollSpeed;
    columnItemsBox.scrollBy({ top: -scrollSpeed, behavior: 'smooth' });
  } else if (e.clientY > rect.bottom - scrollZoneHeight) {
    const distanceToBottom = e.clientY - (rect.bottom - scrollZoneHeight);
    scrollSpeed = (distanceToBottom / scrollZoneHeight) * maxScrollSpeed;
    columnItemsBox.scrollBy({ top: scrollSpeed, behavior: 'smooth' });
  }
};

export const formatPlace = (dropData) => {
  return { ...dropData.placeData, id: uuidv4() };
};

export const isSamePlace = (savedPlace, placeData) => {
  return savedPlace.name === placeData.name &&
         savedPlace.city === placeData.city &&
         savedPlace.country === placeData.country &&
         savedPlace.rating === placeData.rating &&
         savedPlace.notes === placeData.notes &&
         JSON.stringify(savedPlace.types) === JSON.stringify(placeData.types);
};

export const addPlaceIfNotExists = (placeData, itinerary, savedPlaces, savePlace) => {
  const itineraryPlaces = savedPlaces[itinerary.id] || [];
  const placeExists = itineraryPlaces.some(savedPlace => isSamePlace(savedPlace, placeData));
  if (!placeExists) {
    savePlace(placeData);
  }
  return placeExists;
};

export const updateColumns = (columns, columnId, place, action, index = null) => {
  return columns.map((column) => {
    if (column.id === columnId) {
      let items = column.items.filter(item => item.id !== place.id);
      if (action === 'add') {
        if (index === null) {
          items.push(place);
        } else {
          items.splice(index, 0, place);
        }
      }
      column.items = items;
    }
    return column;
  });
};
